import { Link, TextLabel2, TextTitle3 } from '@cbhq/cds-web/typography';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { Pictogram } from '@cbhq/cds-web/illustrations/Pictogram';

export function ExploreAboutCard() {
  return (
    <VStack background="bg" paddingY={3} borderRadius={300}>
      <VStack gap={1} paddingX={3}>
        <TextTitle3 as="h1" testID="explore-about-title">
          About Verified Pools
        </TextTitle3>
        <HStack>
          <TextLabel2 color="fgMuted" as="p">
            Coinbase Verified Pools are onchain liquidity pools that allows regulated entities and
            individual traders to operate onchain with greater confidence and regulatory clarity.{' '}
            <Link
              color="fgPrimary"
              href={(process.env.NEXT_PUBLIC_DOCS_URL ?? '') + '/pools'}
              underline={false}
              openInNewWindow
            >
              Learn more
            </Link>
          </TextLabel2>
          <Pictogram name="verifiedPools" />
        </HStack>
      </VStack>
    </VStack>
  );
}
